module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }]
  }, [_c('label', [_vm._v("\n        " + _vm._s(_vm.t(_vm.displayName)) + "\n    ")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": _vm.dynamicSearch ? _vm.t('Type to search') : _vm.t('Select'),
      "options": _vm.availableValues,
      "multiple": _vm.isMultiple,
      "limit": 15,
      "options-limit": 1000,
      "limit-text": _vm.limitText,
      "close-on-select": _vm.closeOnSelect,
      "clear-on-select": false,
      "track-by": "id",
      "label": "name",
      "group-values": _vm.group ? 'rows' : '',
      "internalSearch": !_vm.group,
      "group-label": "name",
      "group-select": _vm.group,
      "loading": _vm.loading
    },
    on: {
      "open": _vm.onOpen,
      "input": _vm.onInput,
      "search-change": _vm.searchChange
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('div', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v(_vm._s(_vm.t('List is empty')))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c6b9768!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/filter/SelectComponent.vue
// module id = 1301
// module chunks = 2